import React, { useState } from 'react'
import { Box } from "@mui/material";
import bg_signup from "../images/bg-signup.png";
import bg_6 from "../images/bg6.png";
import bg_7 from "../images/bg7.png";
import fb from "../images/fb.png";
import google from "../images/google.png";
import fb_sm from "../images/fb-sm.png";
import google_sm from "../images/google-sm.png";
import { Link } from "react-router-dom";
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import VisibilityIcon from '@mui/icons-material/Visibility';
import Axios from 'axios';

import { GoogleLogin } from 'react-google-login';
import FacebookLogin from 'react-facebook-login/dist/facebook-login-render-props'

import HeaderThree from './header/HeaderThree';
import "./CSS/login.css"


// spinner
import ClipLoader from "react-spinners/PropagateLoader";
import { css } from "@emotion/react";
const override = css`
        display: block;
        margin: 0 auto;
        border-color: red;
        `;


const SignUp = () => {

    const [passwordShown, setPasswordShown] = useState(false);

    const [showName, setName] = useState('');
    const [showEmail, setEmail] = useState('');
    const [showPassword, setPassword] = useState('');

    const [showError, setError] = useState(false);
    const [showError2, setError2] = useState(false);

    let [loading, setLoading] = useState(false);


    const togglePassword = () => {
        setPasswordShown(!passwordShown);
    };


    const onFail = (res) =>{
        console.log(res);
    }

    const responseGoogle = (response) => {
        console.log(response.profileObj);
        signupSocial(response.profileObj.givenName+" "+response.profileObj.familyName, response.profileObj.email, response.profileObj.imageUrl);
    }


    const responseFacebook = (response) => {
        setError2(false);
        console.log(response.name);
        console.log(response.email);
        console.log(response.picture['data']['url']);
        if(response.email == null){
            setError2(true);
        }else{
            signupSocial(response.name, response.email, response.picture['data']['url']);
        }
    }


    const signup = () => {
        setError(false);
        setLoading(true);
        Axios.post(window.rootlink+"/register", {
            name: showName,
            email: showEmail,
            password:showPassword
        }).then((v)=>{
            console.log(v);
            console.log(v['data']['status']);
            if(v['data']['status'] == 1){

            }else{
                setError(true);
                setLoading(false);
            }
        });
    };



    const signupSocial = (name_, email_, img) => {
        setError(true);
        setLoading(true);
        Axios.post(window.rootlink+"/register-social", {
            name: name_,
            email: email_,
            img:img
        }).then((v)=>{
            console.log(v);
            console.log(v['data']['status']);
            if(v['data']['status'] == 1){
                setLoading(false);

            }else{
                setError(true);
                setLoading(false);
            }
        });
    };
    return (
        <>
        
        <link href="/card.css" rel="stylesheet" type="text/css" />

        {/* <HeaderThree /> */}
        <div >
            <Link 
                to="/"
                className="home-button"
            >
                <h4 style={{
                    marginRight: "7px",
                    color: "#ff2c48",
                }} typeof="text">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-left" viewBox="0 0 16 16">
                        <path fill-rule="evenodd" d="M15 8a.5.5 0 0 0-.5-.5H2.707l3.147-3.146a.5.5 0 1 0-.708-.708l-4 4a.5.5 0 0 0 0 .708l4 4a.5.5 0 0 0 .708-.708L2.707 8.5H14.5A.5.5 0 0 0 15 8z"/>
                    </svg>
                </h4>
                <h4 style={{color: "#bdadad"}}>Home</h4>
            </Link>
        </div>
            <Box
                sx={{
                    background: "transparent",
                    width: { md: "100%", xs: "92%" },
                    height: { md: "950px", xs: "600px" },
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    flexDirection: { md: "row", xs: 'column' },
                    backgroundImage: { md: `url(${bg_signup})`, xs: "none" },
                    backgroundRepeat: "no-repeat",
                    backgroundSize: "700px 950px",
                    backgroundPosition: "right",
                    margin: { md: "90px  auto 0", xs: "155px auto 50px" },
                    "&::after": {
                        content: "''",
                        backgroundImage: { md: `url(${bg_7})`, xs: `url(${bg_6})` },
                        bottom: { md: "0", xs: "auto" },
                        left: "0",
                        top: { md: 0, xs: "90px" },
                        right: { md: "0", xs: "none" },
                        position: "absolute",
                        width: { md: "383px", xs: "84px" },
                        height: { md: "755px", xs: "355px" },
                        zIndex: "-1",
                    },
                    "&::before": {
                        content: "''",
                        background: "rgba(100, 151, 255, 0.3)",
                        filter: "blur(200px)",
                        right: 0,
                        bottom: 0,
                        position: "absolute",
                        display: { md: "block", xs: "none" },
                        width: "770px",
                        height: "617px",
                        zIndex: "-1",
                    }
                }}
            >
                <div className="container login">
                    <Box
                        sx={{
                            background: "transparent",
                            margin: { md: "0 auto", xs: "0" },
                            width: "100%",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                        }}
                    >
                        <div className="form">
                            <div className="form-title">Create Account</div>
                            <div className="btn-gp">


                                
                                <GoogleLogin
                                    clientId={'848915360523-654tco324v1fibeq998o6ucmh05cspc6.apps.googleusercontent.com'}
                                    onSuccess={responseGoogle}
                                    onFailure={onFail}
                                    cookiePolicy={'single_host_origin'}
                                    className={'btn-social'}
                                    render={renderProps => (
                                        <button className="btn-social" onClick={renderProps.onClick} disabled={renderProps.disabled}>
                                            <img className="lg" src={google} alt="alt='signup with Google" />
                                            <img className="sm" src={google_sm} alt="alt='signup with Google" />
                                        </button>
                                      )}
                                    
                                />

                                {/* <button className="btn-social">
                                    <img className="lg" src={google} alt='signup with Google' />
                                    <img className="sm" src={google_sm} alt='signup with Google' />
                                </button> */}


                                {/* <FacebookLogin
                                    appId="983175575727533"
                                    autoLoad={false}
                                    fields="name,email,picture"
                                    callback={responseFacebook}
                                    render={renderProps => (
                                        <button className="btn-social" onClick={renderProps.onClick}>
                                        <img className="lg" src={fb} alt='signup with Facebook' />
                                        <img className="sm" src={fb_sm} alt='signup with Facebook' />
                                        </button>
                                      )}
                                    /> */}


                                <button className="btn-social">
                                    <img className="lg" src={fb} alt='signup with Facebook' />
                                    <img className="sm" src={fb_sm} alt='signup with Facebook' />
                                </button>
                            </div>
                            <div className="form-p"> -OR- </div>
                            <form action=" " method="post" onSubmit={(e)=>{e.preventDefault();}}>
                                <input type="text" name="full_name" id="full_name" placeholder='Full Name' onChange={(e)=>{setName(e.target.value);}} />
                                <input type="email" name="email" id="email" placeholder='Email Address' onChange={(e)=>{setEmail(e.target.value);}} />
                                <input type={passwordShown ? "text" : "password"} name="password" id="password" placeholder='Password' onChange={(e)=>{setPassword(e.target.value);}} />
                                <div onClick={togglePassword} className="icon">
                                    {passwordShown ?
                                        <VisibilityIcon sx={{ color: "#fff" }} /> :
                                        <VisibilityOffIcon sx={{ color: "#bdadad" }} />
                                    }
                                </div>

                                { showError ?

                                    <span style={{color:'red'}} >Email already exsist!</span> :  <span></span>

                                    }

                                    
                                { showError2 ?

                                    <span style={{color:'red'}} >Your Facebook account not link email</span> :  <span></span>

                                    }


                                {/* <Link to="/nft_marketplace" style={{ padding: '0' }} className="button btn-signup btn-form">Create Account</Link> */}
                                <button className='button btn-signup btn-form' style={{padding:'0'}} onClick = {signup}>
                                
                                {loading ? <span></span> : 'Create Account'}
                                    <ClipLoader color={'#ffff'} loading={loading} css={override} size={10} />
                                
                                </button>


                            </form>
                            <div className="already signup">
                                <span>Already have an account?</span>
                                <Link to="/login">Log in</Link>
                            </div>
                        </div>
                    </Box>
                </div>
            </Box>
        </>
    )
}

export default SignUp